module.exports = pratt.PrattSharedLibs.algoliSearchLite;